export { default as MainTemplate } from './MainTemplate';
export { default as TemplateStyleOne } from './TemplateStyleOne';
export { default as TemplateStyleSix } from './TemplateStyleSix';
export { default as TemplateTwentyFour } from './TemplateTwentyFour';
export { default as TemplateTwentyFive } from './TemplateTwentyFive';
export { default as TemplateStyleSixteen } from './TemplateStyleSixteen';
export { default as TemplateTwentyOne } from './TemplateTwentyOne';
export { default as InspectorTwentyOne } from './InspectorTwentyOne';
export { default as TemplateTwentyTwo } from './TemplateTwentyTwo';
export { default as TemplateNineteen } from './TemplateNineteen';
export { default as TemplateTwelve } from './TemplateTwelve';
export { default as TemplateEleven } from './TemplateEleven';
export { default as TemplateTen } from './TemplateTen';
export { default as TemplateStyleTwo } from './TemplateStyleTwo';
export { default as TemplateStyleFour } from './TemplateStyleFour';
export { default as TemplateStyleFive } from './TemplateStyleFive';
export { default as TemplateStyleSeven } from './TemplateStyleSeven';
export { default as TemplateStyleEight } from './TemplateStyleEight';
export { default as TemplateStyleThree } from './TemplateStyleThree';
export { default as TemplateStyleNine } from './TemplateStyleNine';
export { default as TemplateStyleThirteen } from './TemplateStyleThirteen';
export { default as TemplateStyleFourteen } from './TemplateStyleFourteen';
export { default as TemplateStyleFifteen } from './TemplateStyleFifteen';
export { default as TemplateSeventeen } from './TemplateSeventeen';
export { default as TemplateStyleEighteen } from './TemplateStyleEighteen';
export { default as TemplateTwenty } from './TemplateTwenty';
export { default as TemplateTwentyThree } from './TemplateTwentyThree';


